import { useNavigate } from "react-router-dom";
import { Home, Search, Users } from "lucide-react";
import { cn } from "@/ui";

const ITEMS = [
  { key: "home", label: "Home", Icon: Home, to: "/home" },
  { key: "research", label: "Research", Icon: Search, to: "/chat?tab=research" },
  { key: "groups", label: "Groups", Icon: Users, to: "/social" },
];

export function BottomNav({ active }) {
  const navigate = useNavigate();
  return (
    <nav className="sticky bottom-0 z-30 flex border-t border-border bg-background/90 backdrop-blur-xl">
      {ITEMS.map(({ key, label, Icon, to }) => {
        const on = active === key;
        return (
          <button
            key={key}
            data-testid={`nav-${key}`}
            onClick={() => navigate(to)}
            className={cn(
              "flex flex-1 flex-col items-center gap-1 py-3 transition-colors",
              on ? "text-primary" : "text-muted-foreground hover:text-foreground",
            )}
          >
            <Icon className="h-5 w-5" strokeWidth={on ? 2.4 : 1.8} />
            <span className={cn("text-[11px]", on ? "font-semibold" : "font-medium")}>{label}</span>
          </button>
        );
      })}
    </nav>
  );
}
